/**
 * Function to get the uppermost reachable window object.
 *
 * Iterates through the parent/ancestor windows until the top or topmost window is reached which is allowed to access.
 * (cross-origin restrictions might be present, e.g. if safeframe is used)
 *
 * @returns The topmost reachable window object.
 */
export const getUppermostReachableWindow = <WIN extends Window>(): WIN => {
    let win: Window = window;
    let count: number = 0;
    try {
        // iterate through the parent windows until the topmost window is reached
        // prevent infinite loops in case of manipulated parent property by limiting the number of iterations
        while (win.parent && win.parent !== win && count++ < 20) {
            // attempt to access the parent's location - this will throw if there are cross-origin restrictions
            !!(win.parent.location.href);
            // if no error was thrown, we can safely assume that the parent is reachable
            win = win.parent;
        }
    } catch (e) {
        // noop
    }
    return win as WIN;
}
